export function verifyRoleAccess(auth, required, verifyAll = false) {
    const { roles, permissions } = auth
    const itemNames = Array.isArray(required) ? required : required ? [required] : []

    // Si itemNames está vacío, retorna 'true' de inmediato
    if (itemNames.length === 0) {
        return true
    }

    // Verificar que el usuario tenga TODOS los roles y permisos.
    if (verifyAll) {
        for (const itemName of itemNames) {
            if (
                !roles[itemName] &&
                !permissions[itemName] &&
                permissions[`${itemName.split(':')[0]}:*`]
            ) {
                // Si el usuario NO tiene uno de los roles o permisos, retorna 'false'
                return false
            }
        }
        return true // El usuario tiene todos los roles y permisos
    }

    // Verificar que el usuario tenga AL MENOS un rol o permiso de los requeridos
    for (const itemName of itemNames) {
        if (
            roles[itemName] ||
            permissions[itemName] ||
            permissions[`${itemName.split(':')[0]}:*`]
        ) {
            return true
        }
    }
    // Si el usuario no tienen ninguno de los roles y/o permisos, retorna 'false'
    return false
}
